<template>
  <div class="nikkud-options" v-if="optionsToDisplay.length > 1">    
    <div 
      class="pb-1 m-0"
      :class="{'mt-4 mb-2':!mobile}"
      ref="unvocalizedList">
      <div class="mb-3 pt-3" v-if="mobile">האם התכוונת למילה אחרת?</div>
      <div class="mb-3" v-else>אנחנו מציגים תוצאות עבור
        <h3 class="f-narkis d-inline"> "{{optionsToDisplay[0]}}" </h3>
        האם התכוונת למילה אחרת?</div>
      <div class="d-flex">
        <div class="search-btns flex-grow-1">
          <b-button         
            @click="runCharuzit(item)"            
            class="f-narkis d-inline-block rounded-pill px-3 shadow-none ml-2 mb-2 pt-1 pb-2  border-0"
            :class="[ mobile ? 'bg-secondary' : 'bg-background']" 
            v-for="(item, index) in optionsToDisplay" :key="index" >
              {{item}}
          </b-button>
        </div>       
      </div>
    </div>
  </div>
</template>
<script>
import {Actions} from '@/store/stateChanges'
export default {
  name: 'NikkudOptions',
  methods: {
    runCharuzit (word) {
      this.$store.commit('SET_TEXT_FOR_CHARUZIT_API_CALL', word)
      this.$store.dispatch(Actions.RUN_CHARUZIT)
      if (this.$route.name !== 'home')
        this.$router.push({ name: "home", query: { search: word } })
    }
  },
  computed: {
    searchTerm () {
      return this.$store.state.soundplayCallText
    },
    nakdanWordsArray () {
      return this.$store.state.soundplayResults
    },
    optionsToDisplay () {
      return this.nakdanWordsArray.filter(e => e.replace(/[^א-ת]/g, '') === this.searchTerm.replace(/[^א-ת]/g, ''))
    },
    mobile () {
      return this.$mq === 'xs'
    }    
  },
  watch: {

  }
}
</script>
<style scoped lang="scss">
  .nikkud-options{
    .search-btns{
      button{
        font-size: 25px;
        line-height: 25px;
        &:nth-of-type(1) {
          display: none!important;
        }
        &:hover {
          //color: var(--primary);
          //border-color: var(--primary)!important;
        }
      }
    }
  }
</style>